module.exports = __webpack_public_path__ + "static/background-steps-27e541222d59ee1af91fb48abd1b335b.png";